export
const flexMap = {

    vertical : 'column',
    horizontal : 'row'
    
}